"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.profession.select.label': 'Scegli la tua professione per iniziare l\'onboarding:',
    'onboarding.profession.select.placeholder': '-- Seleziona Professione --',
    'onboarding.profession.empty': 'Nessuna professione disponibile.',
};
